import { Typography } from '@mui/material'
import { LoginTypes, PageNotFound } from '@procom-labs/common'
import { RedirectAuthPortal } from '@procom-labs/organisms'

import { CommonRoutesPaths } from './routes.enum'

export const publicRoutes = [
  {
    path: '*',
    element: (
      <RedirectAuthPortal
        strictLoginType={LoginTypes.GorillaResume}
        nonRedirectRoutes={Object.values(CommonRoutesPaths)}
      />
    ),
  },
  {
    path: PageNotFound,
    element: (
      <div className="center-screen">
        <Typography paragraph variant="h3">
          Page Not Found
        </Typography>
      </div>
    ),
  },
]
